import React from "react";
import ReusableModal from "../../../components/Modals/ReusableModal";
import CloseSvg from "../../../assets/svgs/CloseSvg";

const AddAppointment = ({
  openConfirmModal,
  setOpenConfirmModal,
  handleSubmit,
  note,
  setNote,
  visitType,
  setVisitType,
  appointmentTypes,
  appointmentVisitType,
  setAppointmentVisitType,
  appointmentType,
  isLoading,
}) => {
  return (
    <ReusableModal open={openConfirmModal} hideHeader>
      <div className="flex flex-col items-center min-w-[480px]">
        <div className="flex flex-row justify-between items-center p-6 w-full">
          <p className="m-0 text-2xl font-bold text-primaryblack">
            Add Appointment
          </p>
          <button
            onClick={() => setOpenConfirmModal(false)}
            className="flex border-[2px] border-primarygrayborder items-center justify-center w-8 rounded-full aspect-square bg-primarylightgrey"
          >
            <CloseSvg color={"#828282"} />
          </button>
        </div>
        <div className="h-[1px] w-full bg-primarygrayborder" />

        <div className="flex flex-col gap-2 p-4 pb-0 w-full">
          <label htmlFor="patientSelect" className="text-sm font-bold">
            Visit Type
          </label>
          <div className="w-full">
            <select
              className="p-2 w-full rounded-md border"
              value={visitType}
              onChange={(e) => setVisitType(e.target.value)}
            >
              <option value="ADHOC">Ad Hoc</option>
              <option value="NORMAL">Normal</option>
            </select>
          </div>
        </div>

        <div className="flex flex-col gap-2 p-4 pb-0 w-full">
          <label htmlFor="patientSelect" className="text-sm font-bold">
            Appointment Visit Type
          </label>
          <div className="w-full">
            <select
              className="p-2 w-full rounded-md border"
              value={appointmentVisitType}
              onChange={(e) => setAppointmentVisitType(e.target.value)}
            >
              <option value="">Select Appointment Visit Type</option>
              {appointmentTypes?.map((type) => (
                <option key={type.value} value={type.value}>
                  {type.label}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div className="flex flex-col gap-2 p-4 w-full">
          <label htmlFor="patientSelect" className="text-sm font-bold">
            Appointment Note (Optional)
          </label>
          <div className="w-full">
            <textarea
              className="w-full border"
              rows={5}
              value={note}
              onChange={(e) => setNote(e.target.value)}
            />
          </div>
        </div>
        <div className="h-[1px] w-full bg-primarygrayborder" />
        <div className="flex flex-row gap-6 justify-between items-center p-4 w-full">
          <button
            onClick={() => setOpenConfirmModal(false)}
            disabled={isLoading}
            className="w-1/2 p-2 font-semibold rounded-md bg-primarylightgrey border-[2px] text-primarytextgrey border-primarygrayborder"
          >
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            disabled={isLoading}
            className="w-1/2 disabled:opacity-40 disabled:cursor-not-allowed font-semibold p-2 border-[2px] rounded-md bg-subtleblue border-primaryblue text-primaryblue whitespace-nowrap"
          >
            Add Appointment
          </button>
        </div>
      </div>
    </ReusableModal>
  );
};

export default AddAppointment;
